// components/Footer.js
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Row className={styles.row}>
        <Col md={4} className={styles.logoSection}>
          <img
            src="/logo_light.png"
            alt="Faheem Logo"
            className={styles.logo}
          />
          <p>
            نقدم خدمة الدروس الخصوصية بشكل فردي عن بعد للطلاب من مرحلة الروضة
            وحتى المرحلة الجامعية عن طريق توفير معلمين ومعلمات أكفاء ومؤهلين
            لمساعدة الطلاب على التفوق والنجاح
          </p>
          <div className={styles.socialMedia}>
            <a
              href="https://x.com/faheemapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.facebook.com/FaheemApp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/faheemapp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </Col>
        <Col md={3} className={styles.linkSection}>
          <ul>
            <li>
              <a
                href={`${process.env.NEXT_PUBLIC_BASE_URL}/terms-and-conditions`}
                target="_blank"
                rel="noopener noreferrer"
              >
                الشروط والأحكام
              </a>
            </li>
          </ul>
        </Col>
        <Col md={5} className={styles.paymentSection}>
          <p className="text-right font-weight-light">
            للحصول على تطبيق فهيم قم بالضغط على أيقونة المتجر المناسب لجهازك
          </p>
          <div
            className="d-flex justify-content-center"
            style={{
              gap: '0.6rem',
            }}
          >
            <a
              href="https://apps.apple.com/sa/app/%D9%81%D9%87%D9%8A%D9%85-%D9%85%D9%86%D8%B5%D8%A9-%D9%81%D9%87%D9%8A%D9%85-%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85%D9%8A%D8%A9/id1363295457?l=ar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/ios.svg" alt="iOS" className={styles.appLogo} />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.faheemapp.android&hl=ar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/android.svg"
                alt="Google Play"
                className={styles.appLogo}
              />
            </a>
          </div>
        </Col>
      </Row>
      <Row className={styles.copyright}>
        <p>جميع الحقوق محفوظة لفهيم. 2024</p>

        <img key={1} src={'/paymentmethods_2.webp'} alt="payment methods" />
      </Row>
    </footer>
  );
};

export default Footer;
